import React, { Component } from "react";
import { connect } from "react-redux";

import CookieConsent from "react-cookie-consent";
import GDRPModal from "containers/GDPR/GDPRModal";
import Aux from "hoc/ReactAux/ReactAux";
import { fetchingPrivacyPolicy } from "actions/Gdpr";

class CookieApproval extends Component {
  state = {
    showModal: false
  };

  constructor(props) {
    super(props);
    this.escFunction = this.escFunction.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  escFunction = event => {
    if (event.keyCode === 27) {
      this.setState({ showModal: false });
    }
  };

  handlePrivacyPolicy = () => {
    this.props.onFetchingPrivacyPolicy();
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    return (
      <Aux>
        <CookieConsent location="top" expire={365} style={{ zIndex: "999999" }}>
          <span>
            {"This website uses cookies to enhance the user experience"}
          </span>{" "}
          {" - "}
          <a onClick={this.handlePrivacyPolicy} style={{ color: "blue" }}>
            {" "}
            {"Privacy Policy"}{" "}
          </a>
        </CookieConsent>
        <GDRPModal
          style={{
            top: "15%",
            right: "1%",
            height: "60%",
            width: "98%",
            overflow: "hidden"
          }}
          show={this.state.showModal}
          privacyPolicy={this.props.privacyPolicy}
          closeModal={this.handleCloseModal}
          isTermsConditions={false}
        />
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    privacyPolicy: state.gdprReducer.privacyPolicy
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchingPrivacyPolicy: () => dispatch(fetchingPrivacyPolicy())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CookieApproval);



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuComponents/CookieApproval/index.js